import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AnyIntegration, IIntegrationFoyr } from '../../../../interfaces/restaurant';

type EditIntegrationFoyrForm = {
  proxy: FormControl<boolean>;
  proxyUnifiedMode: FormControl<boolean>;
  restaurantId: FormControl<string>;
};

@UntilDestroy()
@Component({
  selector: 'app-edit-integration-foyr',
  templateUrl: './edit-integration-foyr.component.html',
  styleUrls: ['./edit-integration-foyr.component.scss']
})
export class EditIntegrationFoyrComponent implements OnInit {

  @Input() set data(value: AnyIntegration) {

    if (value && value.provider === 'foyr') {
      const foyrValue = value as IIntegrationFoyr;

      this.editIntegrationForm.get('proxy')?.setValue(foyrValue.proxy ?? false, { emitEvent: false });
      const proxyUnifiedModeControl = this.editIntegrationForm.get('proxyUnifiedMode');

      if (foyrValue.proxy) {
        proxyUnifiedModeControl?.enable({ emitEvent: false });
        proxyUnifiedModeControl?.setValue(foyrValue.proxyUnifiedMode ?? false, { emitEvent: false });
      } else {
        proxyUnifiedModeControl?.disable({ emitEvent: false });
        proxyUnifiedModeControl?.setValue(false, { emitEvent: false });
      }

      this.editIntegrationForm.patchValue(foyrValue.credentials);
    }
  }

  public editIntegrationForm: FormGroup<EditIntegrationFoyrForm> = new FormGroup({
      proxy: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.required] }),
      proxyUnifiedMode: new FormControl<boolean>(
        { value: false, disabled: true },
        { nonNullable: true, validators: [Validators.required] }
      ),
      restaurantId: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      })
    }
  );

  @Output() edited = new EventEmitter<Partial<AnyIntegration>>();
  @Output() remove = new EventEmitter<void>();

  constructor(
    public dialogRef: MatDialogRef<any>,
    public notifier: NotifierService,
  ) {}

  ngOnInit(): void {
    this.addListeners();
  }

  private addListeners(): void {
    this.editIntegrationForm.get('proxy')?.valueChanges.pipe(
      untilDestroyed(this)
    ).subscribe((proxyValue: boolean) => {
      const proxyUnifiedModeControl = this.editIntegrationForm.get('proxyUnifiedMode');

      if (!proxyValue) {
        proxyUnifiedModeControl?.disable({emitEvent: false});
        proxyUnifiedModeControl?.setValue(false, { emitEvent: false });
      } else {
        proxyUnifiedModeControl?.enable({emitEvent: false});
      }
    });
  }

  public edit(): void {
    const formValue = this.editIntegrationForm.getRawValue();

    this.edited.emit({
      proxy: formValue.proxy,
      proxyUnifiedMode: formValue.proxyUnifiedMode,
      credentials: {
        restaurantId: formValue.restaurantId,
      }
    });
  }

  public removeIntegration(): void {
    this.remove.emit();
  }
}
